export default __webpack_public_path__ + "static/media/secure-job-shaded.68a80ecc.png";